export function getClientTimezoneName() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
